import { Dialog, DialogContent, DialogTitle, Grid, MenuItem, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { TitleText } from '../../../component/layout/layoutMainStyle'
import FilterSelect from '../../../component/select/filterSelect'
import ButtonCustom from '../../../component/button/buttonCustom'
import InputDatePicker from '../../../component/input/inputDatePicker'
import { icons } from '../../../constants/images'
import DepartmentApi from '../../../api/departments/departments.api'
import EmployeesApi from '../../../api/employees/employees.api'
import moment from 'moment'
import FolderApi from '../../../api/folder/folder.api'
import { swalError, swalSuccess } from '../../../component/notification/swal'
import ClearIcon from '@mui/icons-material/Clear';

type PropsDialogPermis = {
    openPermis: boolean
    handleClosePermis: any
    idFolder: number
    loadData: any
}
const initStateErrorMessage = {
    DepartmentName: "",
    permissionLevel: "",
    expiredDate: ""
};
export default function DialogPermis(props: PropsDialogPermis) {
    const { openPermis, handleClosePermis, idFolder, loadData } = props
    const [errorMessage, setErrorMessage] = useState<any>(initStateErrorMessage);
    const clearErrorMessage = () => setErrorMessage(initStateErrorMessage);
    const [departments, setDepartments] = useState<any[]>([])
    const [employees, setEmployees] = useState<any[]>([])
    const [permission, setPermission] = useState<any[]>([
        {
            idDepartment: null,
            idEmployee: null,
            permissionLevel: null,
            expiredDate: ""
        }
    ])
    const getDepartments = async () => {
        const res = await DepartmentApi.getDepartments({})
        const data = res.data
        if (data.success) {
            setDepartments(data.result.items)
        }
    }
    const getEmployees = async (idDepartment?: number) => {
        const res = await EmployeesApi.getEmployees({ idDepartment })
        const data = res.data
        if (data.success) {
            setEmployees([{ idEmployee: 'all', employeeFirstname: 'ทั้งหมด' }, ...data.result.items])
        }


    }
    const getPermissionFolder = async () => {
        const res = await FolderApi.getPermissionFolder(idFolder)
        const data = res.data
        if (data.success) {
            setPermission(data.result?.map((x: any) => {
                x.idDepartment = !x.idDepartment ? 'all' : x?.idDepartment
                x.idEmployee = !x.idEmployee ? 'all' : x?.idEmployee
                return x
            }))
        }
    }

    useEffect(() => {
        if (openPermis) {
            getDepartments()
            getPermissionFolder()
            getEmployees()
        }
    }, [openPermis])

    const patchPermissionFolder = async () => {
        if (permission?.filter((x) => !x?.idDepartment)?.length > 0)
            return setErrorMessage({
                ...errorMessage,
                ...{ DepartmentName: `กรุณาเลือกหน่วยงาน` },
            });
        if (permission?.filter((x) => !x?.permissionLevel)?.length > 0)
            return setErrorMessage({
                ...errorMessage,
                ...{ permissionLevel: `กรุณาเลือกสิทธิ์` },
            });
        if (permission?.filter((x) => !x?.expiredDate)?.length > 0)
            return setErrorMessage({
                ...errorMessage,
                ...{ expiredDate: `กรุณาเลือกวันที่` },
            });
        const body = {
            detailPermission: permission.map((x: any) => {
                x.idDepartment = x?.idDepartment === 'all' ? null : x?.idDepartment
                x.idEmployee = x?.idEmployee === 'all' ? null : x?.idEmployee
                return x
            })
        }
        await FolderApi.patchPermissionFolder(idFolder, body).then(async (res) => {
            if (res?.data?.success) {
                handleClosePermis()
                swalSuccess("อัพเดทการเข้าถึงพื้นที่จัดเก็บสำเร็จ")
                loadData()
                clearErrorMessage()
            } else {
                handleClosePermis()
                swalError(res.data.description || res.data.message);
                clearErrorMessage()
            }

        }).catch((error: any) => {
            handleClosePermis()
            swalError(error.response.data.description || error.response.data.message);
            clearErrorMessage()
        })
    }

    return (
        <Dialog
            open={openPermis}
            keepMounted
            onClose={() => {
                handleClosePermis()
                clearErrorMessage()
            }}
            fullWidth
            maxWidth='lg'
        >
             <DialogTitle sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <ClearIcon sx={{ cursor: 'pointer', fontSize: "20px" }} onClick={() => {
                      handleClosePermis()
                      clearErrorMessage()
                }} />
            </DialogTitle>
            <DialogContent sx={{ padding: '32px', gap: '32px', display: 'flex', flexDirection: "column" }}>
                <div style={{ display: "flex", justifyContent: 'center', width: '100%' }}>
                    <TitleText>การเข้าถึงพื้นที่จัดเก็บ</TitleText>
                </div>
                <div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginBottom: '16px'
                    }}>
                        <Typography>รายชื่อ</Typography>
                        <ButtonCustom variant={'outlined'}
                            startIcon={<icons.circleButton />}
                            textButton={'เพิ่มรายชื่อ'}
                            onClick={() => {
                                setPermission([...permission,
                                {
                                    idDepartment: null,
                                    idEmployee: null,
                                    permissionLevel: null,
                                    expiredDate: ""
                                }
                                ])
                            }} />
                    </div>
                    {permission?.map((item: any, i: number) => {
                        return (
                            <Grid container spacing={1} sx={{ display: "flex", alignItems: "center" }}>
                                <Grid item md={3} xs={12} sx={{ marginBottom: '20px' }}>
                                    <FilterSelect heading='หน่วยงาน*' labelId='' selectId='' options={[{idDepartment:'all', departmentName: 'ทุกหน่วยงาน'},...departments]?.map((x, i) => {
                                        return (
                                            <MenuItem key={i}
                                                value={x.idDepartment}
                                            >
                                                {x.departmentName}
                                            </MenuItem>
                                        )
                                    })} value={item.idDepartment} onchange={(e: any) => {
                                        setPermission((prevData: any) => {
                                            const newData = [...prevData];
                                            newData[i] = { ...newData[i], idDepartment: e.target.value };
                                            return newData;
                                        });
                                        getEmployees(e.target.value)
                                        clearErrorMessage()

                                    }}
                                        helperText={
                                            errorMessage.DepartmentName || ''
                                        } />
                                </Grid>
                                <Grid item md={4} sx={{ marginBottom: '20px' }}>
                                    <FilterSelect heading='พนักงาน' labelId='' selectId='' options={

                                        employees?.map((x, i) => {
                                            return (

                                                <MenuItem key={i}
                                                    value={x.idEmployee}
                                                >
                                                    {x.employeeFirstname}  {x.employeeLastname}
                                                </MenuItem>

                                            )
                                        })
                                    } value={item.idEmployee || ''} onchange={(e: any) => {
                                        setPermission((prevData: any) => {
                                            const newData = [...prevData];
                                            newData[i] = { ...newData[i], idEmployee: e.target.value };
                                            return newData;
                                        });
                                    }}
                                    />
                                </Grid>
                                <Grid item xs={2} sx={{ marginBottom: '20px' }}>
                                    <FilterSelect heading='สิทธิ์การเข้าถึงเอกสาร' labelId='' selectId='' options={[
                                        { value: '1', name: 'ดู' },
                                        { value: '2', name: 'แก้ไข' },
                                    ].map((x, i) => {
                                        return (
                                            <MenuItem key={i}
                                                value={x.value}
                                            >
                                                {x.name}
                                            </MenuItem>
                                        )
                                    })} value={item.permissionLevel || ''} onchange={(e: any) => {
                                        setPermission((prevData: any) => {
                                            const newData = [...prevData];
                                            newData[i] = { ...newData[i], permissionLevel: e.target.value };
                                            return newData;
                                        });
                                        clearErrorMessage()
                                    }}
                                        helperText={
                                            errorMessage.permissionLevel || ''
                                        } /></Grid>

                                <Grid item xs={2} sx={{ marginBottom: '20px' }}>
                                    <InputDatePicker
                                        dateFormat="DD/MM/YYYY"
                                        required={false}
                                        key={""}
                                        disabled={false}
                                        label=""
                                        value={item.expiredDate}
                                        onClear={() => {
                                            setPermission((prevData: any) => {
                                                const newData = [...prevData];
                                                newData[i] = { ...newData[i], expiredDate: '' };
                                                return newData;
                                            })
                                        }}
                                        onChange={(e: any) => {
                                            setPermission((prevData: any) => {
                                                const newData = [...prevData];
                                                newData[i] = { ...newData[i], expiredDate: moment(e).format("YYYY-MM-DD") };
                                                return newData;
                                            })
                                            clearErrorMessage()
                                        }
                                        }
                                        allowClear
                                        heading={'ถึงวันที่'}
                                        helperText={
                                            errorMessage.expiredDate || ''
                                        } />
                                </Grid>
                                <Grid item xs={1}>
                                    <ButtonCustom variant='outlined' textButton={'ลบ'} onClick={() => setPermission(permission.filter((x, index) => i !== index))} btnStyle={{
                                        '&.MuiButton-outlined': {
                                            marginTop: '12px',
                                            color: `red !important`,
                                            border: `2px solid red !important`,
                                            borderRadius: "10px !important",
                                            '&:hover': {
                                                color: `red  !important`,
                                                border: `2px solid red !important`,
                                                backgroundColor: '#EFFFF7 !important'
                                            },
                                        },
                                    }} style={{ margin: "auto" }} />
                                </Grid>
                            </Grid>
                        )
                    })}

                </div>

                <ButtonCustom disabled={permission?.filter((x) => !x?.idDepartment)?.length > 0} textButton={'บันทึก'} onClick={() => patchPermissionFolder()} style={{ margin: "auto" }} />
            </DialogContent>

        </Dialog>
    )
}
